// components/HostCrownBadge.jsx: M3-12 small pixel-art crown next to
// the host's name in the occupant list. Inline SVG so it scales with
// font size and stays single-color (synthesis §4.2 yellow accent).
// Phase 3 #9: extended to also render a literal "host" text label
// alongside the crown (label text + aria-label via host-badge-helpers).

import { hostLabelText, hostBadgeAriaLabel, hostBadgeShortLabel } from './host-badge-helpers.js';

/**
 * The crown paints in currentColor: the stylesheet sets it (gold, or the
 * darker cream-look gold on cream rows). A `color` prop still wins.
 *
 * @param {{ size?: number, color?: string }} props
 */
export function HostCrownBadge({ size = 14, color }) {
  return (
    <span
      class="host-crown-badge"
      data-testid="host-crown-badge"
      aria-label={hostBadgeShortLabel()}
      role="img"
      title={hostBadgeAriaLabel()}
      style={color ? { color } : undefined}
    >
      <svg
        width={size}
        height={size}
        viewBox="0 0 14 14"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        focusable="false"
        shape-rendering="crispEdges"
      >
        {/* Pixel-art crown, 14x14, single fill, 4 spikes, a band, and
            two gem squares. Designed to read cleanly at 14-20px. */}
        <path
          fill="currentColor"
          d="M1 4h2v2h2V3h1v3h2V3h1v3h2V4h2v6H1V4zm0 7h12v2H1v-2z"
        />
        <rect x="3" y="11" width="2" height="2" fill="#1A1422" />
        <rect x="9" y="11" width="2" height="2" fill="#1A1422" />
      </svg>
      {/* Phase 3 #9: literal visible "host" text label next to the crown.
          aria-hidden so it doesn't double-read with the span's aria-label. */}
      <span class="host-crown-label" data-testid="host-crown-label" aria-hidden="true">
        {hostLabelText()}
      </span>
    </span>
  );
}
